// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5141":"1c29d9d7913ab115","8943":"30a6eed42aca2181"}[chunkId] + ".css";
};